/**
 * cityToAirport.js - Maps US cities to their primary airport codes
 * Used for auto-populating flight searches from clinical trial locations
 */

export const cityToAirport = {
  // Major US Cities - Primary Airports
  'Los Angeles': 'LAX',
  'San Francisco': 'SFO',
  'San Diego': 'SAN',
  'San Jose': 'SJC',
  'Sacramento': 'SMF',
  'Oakland': 'OAK',
  
  'New York': 'JFK',
  'Brooklyn': 'JFK',
  'Manhattan': 'JFK',
  'Queens': 'JFK',
  'Bronx': 'LGA',
  
  'Boston': 'BOS',
  'Cambridge': 'BOS',
  
  'Chicago': 'ORD',
  
  'Houston': 'IAH',
  'Dallas': 'DFW',
  'Fort Worth': 'DFW',
  'Austin': 'AUS',
  'San Antonio': 'SAT',
  
  'Phoenix': 'PHX',
  'Tucson': 'TUS',
  
  'Philadelphia': 'PHL',
  'Pittsburgh': 'PIT',
  
  'Seattle': 'SEA',
  'Portland': 'PDX',
  
  'Denver': 'DEN',
  
  'Atlanta': 'ATL',
  
  'Miami': 'MIA',
  'Fort Lauderdale': 'FLL',
  'Tampa': 'TPA',
  'Orlando': 'MCO',
  'Jacksonville': 'JAX',
  
  'Las Vegas': 'LAS',
  'Reno': 'RNO',
  
  'Detroit': 'DTW',
  
  'Minneapolis': 'MSP',
  'St. Paul': 'MSP',
  'Saint Paul': 'MSP',
  
  'Charlotte': 'CLT',
  'Raleigh': 'RDU',
  'Durham': 'RDU',
  
  'Nashville': 'BNA',
  'Memphis': 'MEM',
  
  'Baltimore': 'BWI',
  'Washington': 'DCA',
  'Arlington': 'DCA',
  
  'St. Louis': 'STL',
  'Saint Louis': 'STL',
  
  'New Orleans': 'MSY',
  
  'Salt Lake City': 'SLC',
  
  'Cleveland': 'CLE',
  'Columbus': 'CMH',
  'Cincinnati': 'CVG',
  
  'Indianapolis': 'IND',
  
  'Milwaukee': 'MKE',
  
  'Kansas City': 'MCI',
  
  'Omaha': 'OMA',
  
  'Albuquerque': 'ABQ',
  
  'Honolulu': 'HNL',
  
  'Anchorage': 'ANC',
  
  // Add more as needed...
};

/**
 * Get airport code for a city
 * @param {string} cityName - City name from trial location
 * @returns {string|null} - Airport IATA code or null if not found
 */
export const getAirportForCity = (cityName) => {
  if (!cityName) return null;
  
  // Clean up city name - remove state, zip, extra spaces
  let cleanCity = cityName.trim();
  
  // Remove state abbreviations and zip codes (e.g., "New York, NY" → "New York")
  cleanCity = cleanCity.replace(/,.*$/, '').trim();
  
  // Try exact match first
  if (cityToAirport[cleanCity]) {
    console.log(`✅ Exact match: "${cleanCity}" → ${cityToAirport[cleanCity]}`);
    return cityToAirport[cleanCity];
  }
  
  // Try case-insensitive match
  const match = Object.keys(cityToAirport).find(
    key => key.toLowerCase() === cleanCity.toLowerCase()
  );
  
  if (match) {
    console.log(`✅ Case-insensitive match: "${cleanCity}" → ${cityToAirport[match]}`);
    return cityToAirport[match];
  }
  
  console.log(`❌ No match found for: "${cleanCity}" (original: "${cityName}")`);
  return null;
};

/**
 * Get airport object for autocomplete component
 * @param {string} cityName - City name from trial location
 * @returns {object|null} - Airport object {iataCode, cityName, airportName} or null
 */
export const getAirportObjectForCity = (cityName) => {
  console.log('🔍 getAirportObjectForCity called with:', cityName);
  
  const airportCode = getAirportForCity(cityName);
  if (!airportCode) {
    console.log('❌ No airport code found');
    return null;
  }
  
  // Clean city name for display
  const cleanCity = cityName.trim().replace(/,.*$/, '').trim();
  
  const result = {
    iataCode: airportCode,
    cityName: cleanCity,
    name: cleanCity,
    airportName: `${cleanCity} (${airportCode})`,
    countryCode: 'US',
  };
  
  console.log('✅ Returning airport object:', result);
  return result;
};